import type { SearchAlertsJobDetailsModalXinglet } from '@xing-com/crate-jobs-xinglets';

import { JobDetailsCreateAlertModal } from './components';

type Props = {
  isThirdParty: boolean;
};

export default class Modal implements SearchAlertsJobDetailsModalXinglet {
  public getComponent(): React.FC<Props> {
    return ({ isThirdParty }) => (
      <JobDetailsCreateAlertModal isThirdParty={isThirdParty} />
    );
  }
}
